import { AlertOutputType } from '@logz-pkg/enums';
class AlertSamples {
    samples = [];
    columns = [];
}
export class AlertOutputSamplesResponseModel {
    type = AlertOutputType.Json;
    alertSamples = [new AlertSamples()];
}
//# sourceMappingURL=alert-output-samples-response.js.map